import React from 'react'
import { Badge, Box, Button } from '@chakra-ui/react'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import DisplayBooleanAttribute from './DisplayBooleanAttribute'
import DisplayNumberAttribute from './DisplayNumberAttribute'
import DisplayStringAttribute from './DisplayStringAttribute'
import DisplayInputTextAttribute from './DisplayInputTextAttribute'
import Config from '../../../../config'

export default function DisplayTextAttribute({
  stationData,
  attributeData,
  diagramData,
  layout,
}) {
  let displaySize = diagramData?.imageSize
  // console.log('stationData', diagramData.attribute)

  const { t } = useTranslation()
  return (
    <Box
      padding="1"
      w={layout?.w * 20 + '%'}
      borderRadius="lg"
      borderWidth="2"
      className="bg-gray-100 font-semibold border flex justify-center items-center justify-self-center"
    >
      {_.map(diagramData?.attribute, (attr, index) =>
        attr.preferDataType === Config.DataType.DataType.boolean ? (
          <DisplayBooleanAttribute
            attributeData={attr}
            stationData={stationData}
          />
        ) : attr.preferDataType === Config.DataType.DataType.number ? (
          <DisplayNumberAttribute
            attributeData={attr}
            stationData={stationData}
          />
        ) : attr.preferDataType === Config.DataType.DataType.inputText ? (
          attr.inputText
        ) : (
          attr.inputText
        )
      )}
    </Box>
  )
}
